// Plan/tier helpers shared across the app (display + capability gating).
export const PREVIEW_TIERS = [
  { key: "Free", label: "Free" },
  { key: "Pro", label: "Pro" },
  { key: "Orchardist", label: "Orchardist" },
  { key: "CrewBasic", label: "Crew Basic" },
  { key: "CrewPro", label: "Crew Pro" },
  { key: "CrewEnterprise", label: "Crew Enterprise" },
];

export const PLAN_LABEL = Object.fromEntries(PREVIEW_TIERS.map((t) => [t.key, t.label]));

const CREW = new Set(["CrewBasic", "CrewPro", "CrewEnterprise"]);

export const roleForPlan = (plan) => (CREW.has(plan) ? "provider" : "consumer");
export const previewPath = (plan) => (CREW.has(plan) ? "/provider" : "/dashboard");
export const hasFruitProfile = (plan) => CREW.has(plan) || plan === "Orchardist";
